import { processStringValue } from './index';
import type { CountryFilterMode } from '../components/CountryFilterDropdown';
import type { ApiConversationChannel } from '../api';
import {
  ALL_CHANNEL,
  type ConversationChannel,
  AnalyticsMetricValue,
} from '../pages/conversations/const';
import { AnalyticsMetric } from '../pages/analytics/const';

export const processCountryFilters = (countries: any) => {
  const isEnabled =
    Array.isArray(countries?.selected) && countries.selected.length > 0;
  return {
    isEnabled,
    mode: isEnabled
      ? (processStringValue(countries.mode) as CountryFilterMode)
      : undefined,
    selected: isEnabled ? countries.selected : undefined,
  };
};

export const processDurationFilter = (value: any): number | undefined => {
  return value ? +value * 60 : undefined;
};

export const processConversationChannel = (
  channel: ConversationChannel
): ApiConversationChannel | undefined => {
  return channel === ALL_CHANNEL
    ? undefined
    : (channel as ApiConversationChannel);
};

export const convertMetricValueForAPI = (
  metricValue: any,
  metricName?: string
) => {
  if (!metricValue || !metricName) return metricValue;

  const booleanMetrics = [
    AnalyticsMetric.SUCCESS_RATE,
    AnalyticsMetric.ERROR_RATE,
    AnalyticsMetric.USER_ABANDONED,
  ];

  if (booleanMetrics.includes(metricName as AnalyticsMetric)) {
    const trueValues = [
      AnalyticsMetricValue.SUCCESSFUL_CONVERSATIONS,
      AnalyticsMetricValue.CONVERSATIONS_WITH_ERROR,
      AnalyticsMetricValue.CONVERSATIONS_LEFT,
    ];

    const falseValues = [
      AnalyticsMetricValue.NOT_SUCCESSFUL_CONVERSATIONS,
      AnalyticsMetricValue.CONVERSATIONS_WITHOUT_ERROR,
      AnalyticsMetricValue.CONVERSATIONS_COMPLETED,
    ];

    if (trueValues.includes(metricValue)) return true;
    if (falseValues.includes(metricValue)) return false;
  }

  return metricValue;
};

export const buildConversationAPIParams = (
  filters: any,
  pagination: any,
  masterAgentId: string
) => {
  const stringFilters = {
    userId: processStringValue(filters?.user_id),
    userPhone: processStringValue(filters?.user_phone),
    endedAt: processStringValue(filters?.ended_at),
    agentId: processStringValue(filters?.agent_id),
    startedAt: processStringValue(filters?.started_at),
    conversationId: processStringValue(filters?.conversation_id),
    knowledgeBaseId: processStringValue(filters?.knowledge_base_id),
  };

  const countryData = processCountryFilters(filters?.countries);

  const conversationChannel = processConversationChannel(
    filters?.conversation_channel as ConversationChannel
  );

  const durationFilters = {
    moreThan: processDurationFilter(filters?.more_than),
    lessTnan: processDurationFilter(filters?.less_than),
  };

  const completedConversations =
    filters?.completed_conversations !== ''
      ? filters?.completed_conversations
      : undefined;

  const analyticsFilters = {
    metricName: processStringValue(filters?.metric_name),
    metricValue: convertMetricValueForAPI(
      filters?.metric_value,
      filters?.metric_name
    ),
  };

  return {
    botMasterId: processStringValue(filters?.bot_master_id) || masterAgentId,
    page: pagination?.page ?? 0,
    perPage: pagination?.perPage ?? 1,
    params: {
      ...stringFilters,
      ...durationFilters,
      conversationChannel,
      countries: countryData.selected,
      mode: countryData.mode,
      completedConversations,
      ...analyticsFilters,
    },
  };
};
